// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.28-TSS-3034-mcastro-FEATURE-Batch-Grouping-Placements-by-Search.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
